// key - number of questions, value - step on blemish report
import { LEAD_STATUS } from '../../../constants/leadStatuses';

export const questionsStepsMapper = {
    2: 1,
    3: 1,
    4: 1,
    47: 1,
    13: 1,
    57: 1,
    23: 1,
    24: 1,
    6: 1,
    5: 3,
    7: 3,
    29: 3,
    33: 3,
    34: 3,
    35: 3,
    36: 3,
    38: 3,
    39: 3,
    44: 3,
    15: 4,
    18: 4,
    48: 4,
    12: 4,
    21: 4,
    31: 4,
    20: 4,
    37: 4,
    25: 4,
    40: 4,
    41: 4,
    42: 5,
    30: 5,
    27: 5,
    28: 5,
    16: 5,
    58: 5,
    19: 5,
    17: 5,
    26: 5,
    32: 5,
    22: 6,
    43: 6,
    45: 6,
    46: 6,
    8: 6,
    9: 6,
    10: 7,
    11: 7,
};

export const questionsMapper = [
    [1],
    [2, 3, 4, 47, 13, 57, 23, 24, 6],
    [14],
    [5, 7, 29, 33, 34, 35, 36, 38, 39, 44],
    [15, 18, 48, 12, 21, 31, 20, 37, 25, 40, 41],
    [42, 30, 27, 28, 16, 58, 19, 17, 26, 32],
    [22, 43, 45, 46, 8, 9],
    [10, 11],
    [59],
];

export const editableStatus = {
    [LEAD_STATUS.pending]: 'pending',
    [LEAD_STATUS.priced]: 'priced',
    [LEAD_STATUS.priceGiven]: 'price given',
    [LEAD_STATUS.deliveryRequested]: 'delivery requested',
    [LEAD_STATUS.customerAccepted]: 'customer accepted',
    [LEAD_STATUS.inProgress]: 'in progress',
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/constants.js